import cloneDeep from 'lodash/cloneDeep';

import * as Types from './actionTypes';

const initialState = {
  loading: {},
  blocked: {},
  messages: {},
  container: {
    width: 0,
    left: 0,
  },
  currentPageTitle: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.LOADING_STARTED: {
      const {
        payload: { key, page },
      } = action;
      const newState = cloneDeep(state);
      newState.loading[key] = {
        loading: true,
        urls: page.urls,
      };
      return newState;
    }
    case Types.LOADING_DONE: {
      const {
        payload: { key },
      } = action;
      const newState = cloneDeep(state);
      if (newState.loading && newState.loading[key]) {
        newState.loading[key].loading = false;
      }
      return newState;
    }
    case Types.BLOCK: {
      return {
        ...state,
        blocked: {
          ...state.blocked,
          [action.payload.key]: true,
        },
      };
    }
    case Types.UNBLOCK: {
      return {
        ...state,
        blocked: {
          ...state.blocked,
          [action.payload.key]: false,
        },
      };
    }

    case Types.SET_CURRENT_PAGE_TITLE: {
      return {
        ...state,
        currentPageTitle: action.payload.title,
      };
    }
    default:
      return state;
  }
};

export default reducer;
